import { render, staticRenderFns } from "./drinksItem.vue?vue&type=template&id=ce0dd098&scoped=true&"
import script from "./drinksItem.vue?vue&type=script&lang=js&"
export * from "./drinksItem.vue?vue&type=script&lang=js&"
import style0 from "./drinksItem.vue?vue&type=style&index=0&id=ce0dd098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0dd098",
  null
  
)

export default component.exports